import {FeatureFlagConfig} from '@brunata-angular/util';
import {environment} from '../environments/environment';

export const featureFlagConfig: FeatureFlagConfig = {
    url: environment.featureFlagsUrl,
    cacheTimeout: 30_000, // 30 seconds
    allEnabled: environment.env === 'local',
};
